import React, { useState, useEffect } from "react";
import http from "../../services/api";
import { Select, MenuItem, FormControl, Grid } from "@mui/material";

const selectStyle = {
  height: "38px",
  fontFamily: "Poppins, sans-serif",
  fontSize: 12,
};

const labelStyle = {
  fontSize: 11,
  fontWeight: 600,
  color: "#6b7280",
  marginBottom: 4,
  fontFamily: "Poppins, sans-serif",
  display: "block",
};

function CategoriaAtendimentoSelecionada({
  modalidadeId,
  categoriaSecundariaSelecionada,
  setCategoriaSecundariaSelecionada,
  data,
}) {
  const [categoriasPrincipais, setCategoriasPrincipais] = useState([]);
  const [categoriasSecundarias, setCategoriasSecundarias] = useState([]);
  const [categoriasFiltradas, setCategoriasFiltradas] = useState([]);
  const [categoriaPrincipal, setCategoriaPrincipal] = useState("");

  function handleCategoriaPrincipalChange(event) {
    const id = event.target.value;
    setCategoriaPrincipal(id);
    setCategoriasFiltradas(categoriasSecundarias.filter(c => c.categoria_principal_id === +id));
    setCategoriaSecundariaSelecionada("");
  }

  useEffect(() => {
    if (!data?.modalidade_id) return;

    async function GetCategorias() {
      try {
        const response = await http.get(
          `/api/v1/categorias-atendimento/listar?modalidade_id=${data.modalidade_id}`
        );
        const principais = response.data.categoria_principal ?? [];
        const secundarias = response.data.categorias ?? [];

        setCategoriasPrincipais(principais);
        setCategoriasSecundarias(secundarias);

        // FIX: find pode retornar undefined, acesso sem null check crashava a tela
        const principal = principais.find(c => c.id === data.categoria_principal_id);
        const secundaria = secundarias.find(c => c.categoria_secundaria_id === data.categoria_secundaria);

        if (principal?.id) {
          setCategoriaPrincipal(principal.id);
          setCategoriasFiltradas(secundarias.filter(c => c.categoria_principal_id === +principal.id));
        }

        if (secundaria?.categoria_secundaria_id) {
          setCategoriaSecundariaSelecionada(secundaria.categoria_secundaria_id);
        }
      } catch (error) {
        console.error("Erro ao obter categorias", error);
      }
    }

    GetCategorias();
  }, [modalidadeId]);

  return (
    <Grid container spacing={1}>
      <Grid item xs={6}>
        <label style={labelStyle}>Categoria Principal</label>
        <FormControl fullWidth>
          <Select
            value={categoriaPrincipal}
            onChange={handleCategoriaPrincipalChange}
            style={selectStyle}
            displayEmpty
          >
            <MenuItem value="" disabled>Selecione</MenuItem>
            {categoriasPrincipais.map((c) => (
              <MenuItem key={c.id} value={c.id} style={{ fontSize: 12, fontFamily: "Poppins" }}>
                {c.categoria_principal}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item xs={6}>
        <label style={labelStyle}>Categoria Secundária</label>
        <FormControl fullWidth>
          <Select
            value={categoriaSecundariaSelecionada}
            onChange={(e) => setCategoriaSecundariaSelecionada(e.target.value)}
            style={selectStyle}
            displayEmpty
            disabled={!categoriaPrincipal}
          >
            <MenuItem value="" disabled>Selecione</MenuItem>
            {categoriasFiltradas.map((c, i) => (
              <MenuItem key={c.categoria_secundaria_id ?? i} value={c.categoria_secundaria_id} style={{ fontSize: 12, fontFamily: "Poppins" }}>
                {c.categoria_secundaria}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
}

export default CategoriaAtendimentoSelecionada;